class Observer {
  queue = []

  add (item) {
    this.queue.push(item)
  }

  async start () {
    if (this.queue.length) {
      await this.next()
    } else {
      this.complete()
    }
  }

  async next () {
    try {
      await this.queue.shift()()

      if (this.queue.length) {
        this.next()
      } else {
        this.complete()
      }
    } catch (err) {
      this.error()
    }
  }

  error () {
    // nothing to do
  }
}

export default Observer
